import React, { createContext, useContext, useState, useCallback } from 'react';

const Ctx = createContext(null);

export function NavVisibilityProvider({ children }) {
  const [hidden, setHidden] = useState(false);
  const hide = useCallback(() => setHidden(true), []);
  const show = useCallback(() => setHidden(false), []);
  const toggle = useCallback(() => setHidden(h => !h), []);
  return (
    <Ctx.Provider value={{ hidden, hide, show, toggle }}>
      {children}
    </Ctx.Provider>
  );
}

export function useNavVisibility() {
  const v = useContext(Ctx);
  if (!v) throw new Error('useNavVisibility must be used inside NavVisibilityProvider');
  return v;
}
